module.exports = __webpack_public_path__ + "static/media/striped_bar_shotStrip.591bcace.svg";